module.exports = __webpack_public_path__ + "img/exam.148d75b9.svg";